<template>
  <LayoutDefault
    isShowHeader
    title="Регионы"
    isShowFooter
    customFooter
    visibleClose
  >
    <div class="regions">
      <div class="regions__select">
        <p>Выберите регион:</p>
        <Dropdown
          style="width: 100%; max-width: 800px"
          v-model="selectedRegion"
          filter
          showClear
          :options="regionsDataList"
          optionLabel="Name"
          placeholder="Выберите регион"
          class="w-full md:w-14rem"
        />
      </div>

      <div class="regions__direction">
          <p>Выберите направление деятельности:</p>
          <Dropdown
            style="width: 100%; max-width: 800px"
            v-model="selectedDirectionName"
            :options="directionList"
            optionLabel="name"
            placeholder="Выберите направление деятельности"
            class="w-full md:w-14rem"
            @change="setDirection"
            :disabled="selectedRegion === null"
          />
        <!-- <BaseBtn
          :active="selectedDirection === 3"
          @clickBtn="setDirection(3)"
          white
          :disabled="selectedRegion === null"
          text="Производство"
        />
        <BaseBtn
          :active="selectedDirection === 4"
          @clickBtn="setDirection(4)"
          white
          :disabled="selectedRegion === null"
          text="Инжиниринговые услуги"
        />
        <BaseBtn
          :active="selectedDirection === 5"
          @clickBtn="setDirection(5)"
          white
          :disabled="selectedRegion === null"
          text="Программное обеспечение"
        />
        <BaseBtn
          :active="selectedDirection === 2"
          @clickBtn="setDirection(2)"
          white
          :disabled="selectedRegion === null"
          text="Обучение"
        /> -->
      </div>

      <div class="regions__year" v-if="selectedDirection">
        <p>Год:</p>
          <Dropdown
            style="width: 100%; max-width: 800px"
            v-model="selectYear"
            :options="yearsList"
            class="w-full md:w-14rem"
            @change="setInfoByYear"
          />
      </div>

      <FormContentBlock
        v-if="selectYear"
        blokType='HyperText'
        :blokText="regionInfoData.TextHtml"
        @on-editor-input="editorInfo($event)"
        demo
      />

      <p class="regions__message" v-if="sucssesMessage">Данные успешно отправлены</p>

    </div>
    <div class="regions__buttons">
      <BaseBtn text="Сохранить" @clickBtn="saveInfo" :disabled="canSave"/>
      <BaseBtn text="Отменить" @clickBtn="closeRegionEditor"/>
    </div>

    <template #customFooter>
      <div class="regions__buttons">
        <BaseBtnNew
          name="Сохранить"
          @clickBtn="saveInfo"
          :disabled="canSave"
        >
          <SaveIconNew/>
        </BaseBtnNew>
        <BaseBtnNew
          red
          name="Отменить"
          @clickBtn="closeRegionEditor"
        >
        <CancelIcon/>
        </BaseBtnNew>
      </div>
    </template>
  </LayoutDefault>
</template>

<script>
import { ref, computed, onBeforeMount, watch } from 'vue'
import { useStore } from 'vuex'

import LayoutDefault from '@/layout/LayoutDefault'

import BaseBtnNew from '@/components/ui/BaseBtnNew.vue'
import Dropdown from 'primevue/dropdown'
import FormContentBlock from '@/components/elements/FormContentBlock.vue'
import CancelIcon from '@/components/icons/CancelIcon.vue'
import SaveIconNew from '@/components/icons/SaveIconNew.vue'

export default {
  name: 'RegionsEditorView',
  components: {
    LayoutDefault,
    BaseBtnNew,
    CancelIcon,
    SaveIconNew,
    Dropdown,
    FormContentBlock
  },
  setup () {
    const store = useStore()
    const selectedDirection = ref(0)
    const selectedDirectionName = ref(null)
    const selectedRegion = ref(null)
    const selectYear = ref(0)
    const yearsList = ref([2019, 2020, 2021, 2022, 2023, 2024, 2025])
    const canSave = ref(true)

    const directionList = ref([{ name: 'Производство', id: 3 }, { name: 'Инжиниринговые услуги', id: 4 }, { name: 'Программное обеспечение', id: 5 }, { name: 'Обучение', id: 2 }])

    onBeforeMount(() => {
      store.dispatch('SetA_RegionsData')
    })

    const closeRegionEditor = () => {
      selectedRegion.value = null
      selectedDirection.value = 0
      selectYear.value = 0
      selectedDirectionName.value = null
      canSave.value = true
    }

    watch(selectedRegion, (newValue) => {
      if (newValue) {
        selectedDirection.value = 0
        selectYear.value = 0
        selectedDirectionName.value = null
        canSave.value = true
      }
    })

    const regionsDataList = computed(() => {
      return store.getters.getRegionsData
    })
    const regionInfoData = computed(() => {
      return store.getters.getRegionInfoData
    })
    const sucssesMessage = computed(() => {
      return store.getters.getSucssesMessage
    })

    watch(sucssesMessage, (newValue) => {
      if (newValue) {
        setTimeout(() => {
          store.commit('SetM_SucssesMessage', false)
        }, 2000)
      }
    })

    watch(() => regionInfoData?.value?.TextHtml, (newValue, oldValue) => {
      if (newValue === oldValue || newValue === '') {
        canSave.value = true
      } else {
        canSave.value = false
      }
    })

    const setDirection = (id) => {
      selectedDirection.value = id.value.id
      store.dispatch('SetA_RegionInfoData', {
        RegionId: selectedRegion.value.Id,
        UniversalTagId: selectedDirection.value,
        Year: selectYear.value
      })
    }

    const setInfoByYear = () => {
      store.dispatch('SetA_RegionInfoData', {
        RegionId: selectedRegion.value.Id,
        UniversalTagId: selectedDirection.value,
        Year: selectYear.value
      })
    }
    const editorInfo = (e) => {
      regionInfoData.value.TextHtml = e
    }
    const saveInfo = () => {
      store.dispatch('SetA_RegionInfoSave', regionInfoData.value)
      canSave.value = true
    }

    return {
      regionsDataList,
      regionInfoData,
      sucssesMessage,
      selectedRegion,
      selectedDirection,
      selectedDirectionName,
      yearsList,
      selectYear,
      canSave,
      setDirection,
      setInfoByYear,
      closeRegionEditor,
      editorInfo,
      saveInfo,
      directionList
    }
  }
}
</script>

<style lang="scss" scoped>
.regions {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 0 10px;
  height: 70vh;
  max-width: 800px;
  width: 100%;

  &__select {
    padding-top: 15px;
    display: flex;
    justify-content: space-between;
  }

  &__direction, &__select, &__year {
    display: flex;
    flex-direction: column;
    text-align: left;
    gap: 8px;
    width: 100%;
    p {
      font-weight: 500;
      font-size: 18px;
    }
  }

  &__buttons {
    display: flex;
    gap: 12px;
  }

  &__year {
    align-self: self-start;
  }

  &__message {
    font-size: 24px;
  }
}

:deep(.content-block__editor) {
  max-height: 340px;
  overflow: auto;
  width: 100%;
}

:deep(.p-dropdown:hover) {
  border-color: #00ABEC !important;
}
.p-dropdown {
  background-color: #F5F5F5;
  border: 1px solid #C8C8C8;
  border-radius: 6px;
  text-align: left;
  color: #000000;
}
.p-disabled {
  opacity: 0.5;
}
:deep(.p-dropdown) {
  &.p-focus {
    box-shadow: none !important;
    outline: none; /* опционально: убрать outline, если тоже мешает */
  }

  &:focus-visible {
    box-shadow: none !important;
    outline: none;
  }
}
:deep(.base-button) {
  width: 200px;
}
:deep(.footer) {
  justify-content: flex-end !important;
}

:deep(.p-placeholder) {
  color: #000000 !important;
}

</style>
